/**
 * Slider Component
 *
 * @file slider.js
 */

// Swiper'ı ve gerekli CSS dosyalarını içe aktar
// import Swiper from 'swiper';
import $ from 'jquery';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade, Controller, Thumbs, Mousewheel } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
import 'swiper/css/thumbs';
import 'swiper/css/mousewheel';

const slider = (() => {
  /**
   * fullSlider
   * Full width slider settings
   */
  const fullSlider = () => {
    const paginationSpans = document.querySelectorAll('.home-slide-pagination span');
    paginationSpans.forEach((span, index) => {
        span.addEventListener('click', () => {
            fullSliderC.slideTo(index); 
        });
    });
    const fullSliderC = new Swiper('.home-full-slide', {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      effect: 'fade', 
      fadeEffect: {
          crossFade: true 
      },
      loop: false,
      loopAdditionalSlides: 0,
      speed: 1000,
      autoplay: {
        delay: 4000, 
        disableOnInteraction: false,
      },
      on: {
        init: function(){
          const paginationFirstSpan = document.querySelector('.home-slide-pagination span');
          paginationFirstSpan.classList.add("active");
        },
        slideChangeTransitionEnd: function () {
          const paginationSpans = document.querySelectorAll('.home-slide-pagination span');
          paginationSpans.forEach((span, index) => {
            if (index === this.realIndex) {
              span.classList.add('active'); // Aktif slide'a `active` sınıfı ekle
            } else {
              span.classList.remove('active'); // Diğerlerinden kaldır
            }
          });
        },
      },
      // pagination: {
      //   el: '.home-slide-pagination',
      //   clickable: true,
      //   // renderBullet: function (index, className) {
      //   //   if (index <= 8) {
      //   //     return '<span class="' + className + '">' + ("0" + (index + 1)) + "</span>";
      //   //   } else {
      //   //     return '<span class="' + className + '">' + (index + 1) + "</span>";
      //   //   }
      //   // },
      // },
    });
  };

  const homeDonateMethodSlide = () => {
    const homeDonateMethodSlideC = new Swiper('.donate-method-slide', {
      modules: [Navigation],
      slidesPerView: 6.5,
      spaceBetween: 20,
      navigation: {
        nextEl: ".donate-method-next",
        prevEl: ".donate-method-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.4,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        1366: {
          slidesPerView: 5.5,
          spaceBetween: 20,
        },
        1540: {
          slidesPerView: 6.5,
          spaceBetween: 20,
        },
      },
    });
  };

  const homeNewsSlide = () => {
    
    const homeDonateMethodSlideC = new Swiper('.tb-carousel-slide', {
      modules: [Navigation],
      slidesPerView: "auto",
      initialSlide:1,
      spaceBetween: 45,
      loop: true,
      observer: true,
      observeParents: true,
      speed:500,
      navigation: {
        nextEl: ".tb-news-next",
        prevEl: ".tb-news-prev",
      },
      breakpoints: {
        0: {
          spaceBetween: 15,
        },
        768: {
          spaceBetween: 15,
        },
        1024: {
          spaceBetween: 20,
        },
        1366: {
          spaceBetween: 45,
        },
      },
      on: {
        slideChangeTransitionStart: function () {
          const swiperInstance = this;
          const prevSlide = swiperInstance.slides[swiperInstance.activeIndex - 1];
          const targetContainer = document.querySelector('.tb-carousel-active-slide-clon');
    
          if (prevSlide && targetContainer) {
            targetContainer.innerHTML = "";
    
            const anchorTag = prevSlide.querySelector('a');
            if (anchorTag) {
              const clonedAnchor = anchorTag.cloneNode(true);
    
              // Animasyon için sınıf ekle
              clonedAnchor.classList.add('animate-slide');
              targetContainer.appendChild(clonedAnchor);
    
              // Animasyonu etkinleştir
              requestAnimationFrame(() => {
                clonedAnchor.classList.add('animate-slide-active');
              });
    
              // Lazy-loading görselleri yeniden başlat
              const lazyImages = clonedAnchor.querySelectorAll('img.lazy');
              lazyImages.forEach(img => {
                img.src = img.getAttribute('data-src');
              });
            }
          }
        },
      },
    });
    
    function updateSlideClasses(swiper) {
      const slides = swiper.slides;
      const realIndex = swiper.realIndex; // Döngüdeki gerçek indeks
    
      // Geçersiz slayt veya indeks kontrolü
      if (!slides || slides.length === 0 || realIndex < 0) {
        console.error("Geçersiz slayt veya indeks.");
        return;
      }
    
      // Tüm slaytlardan 'active-slide' sınıfını kaldır
      slides.forEach((slide) => {
        slide.classList.remove('active-slide');
      });
    
      // Aktif slayta sınıf ekle
      const activeSlide = slides[swiper.activeIndex];
      if (activeSlide) {
        activeSlide.classList.add('active-slide');
      }
    }
    
    
    
    // homeDonateMethodSlideC.snapGrid[homeDonateMethodSlideC.snapGrid.length - 1] = homeDonateMethodSlideC.slidesGrid[homeDonateMethodSlideC.slidesGrid.length - 1];
  };

  
  const homeAnnouncementsSlide = () => {
    const homeAnnouncementsSlideC = new Swiper('.hm-announcements-slide', {
      modules: [Navigation],
      slidesPerView: 4,
      spaceBetween: 20,
      navigation: {
        nextEl: ".tb-announcements-next",
        prevEl: ".tb-announcements-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1366: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        1540: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
    });
  };

  const campusSlider = () => {
    const campusThumbSlider = new Swiper('.bc-slide-thumb', {
      modules: [Navigation],
      slidesPerView: 12,
      spaceBetween: 10,
      watchSlidesProgress: true,
      // centeredSlides:true,
      breakpoints: {
        0: {
          slidesPerView: 4,
          spaceBetween: 8,
        },
        768: {
          slidesPerView: 8,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 10,
          spaceBetween: 10,
        },
        1366: {
          slidesPerView: 12,
          spaceBetween: 10,
        },
      },
    });
    const campusSlider = new Swiper('.bc-slide', {
      modules: [Navigation, Pagination, Autoplay, EffectFade, Thumbs],
      loop: false,
      loopAdditionalSlides: 0,
      thumbs: {
        swiper: campusThumbSlider
      }
    });
  };

  const rentalHousingDetailSlider = () => {
    const mainEl = document.querySelector('.bid-image-slider');
    const thumbEl = document.querySelector('.bid-image-slider-nav');
    if (!mainEl || !thumbEl) return;

    const thumbSlider = new Swiper('.bid-image-slider-nav', {
      modules: [Navigation],
      slidesPerView: 7,
      spaceBetween: 9,
      watchSlidesProgress: true,
      breakpoints: {
        0: {
          slidesPerView: 3,
          spaceBetween: 8,
        },
        768: {
          slidesPerView: 6,
          spaceBetween: 8,
        },
        992: {
          slidesPerView: 5,
          spaceBetween: 9,
        },
        1280: {
          slidesPerView: 7,
          spaceBetween: 9,
        },
      },
    });

    const mainSlider = new Swiper('.bid-image-slider', {
      modules: [Navigation, Thumbs],
      loop: false,
      loopAdditionalSlides: 0,
      navigation: {
        nextEl: '.bid-next',
        prevEl: '.bid-prev',
      },
      thumbs: {
        swiper: thumbSlider,
      },
    });
  };
  
  const userAccountSlider = () => {
    const userAccountSlider = new Swiper('.user-account-slider', {
      modules: [Navigation, Pagination, Autoplay],
      loop: false,
      speed: 1000,
      autoplay: {
        delay: 4000, 
        disableOnInteraction: false,
      },
      pagination: {
        el: '.user-account-slider-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
      },
    });
  };

  const donateImageSlider = () => {
    const donateImageSlider = new Swiper('.donate-image-slider', {
      modules: [Navigation, Pagination, Autoplay],
      loop: false,
      speed: 1000,
      navigation: {
        nextEl: ".donate-image-slider-arrow-next",
        prevEl: ".donate-image-slider-arrow-prev",
      },
    });
  };

  const init = () => {
    fullSlider();
    homeDonateMethodSlide();
    homeNewsSlide();
    homeAnnouncementsSlide();
    campusSlider();
    rentalHousingDetailSlider();
    userAccountSlider();
    donateImageSlider();
  };

  return {
    init,
  };
})();

export default slider;
